import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "components/modify/Save";
import Snackbar from "@material-ui/core/Snackbar";

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    "flex-direction": "column",
    "justify-content": "space-between",
    position: "fixed",
    width: "30%",
    height: "15%",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "text-align-last": "center",
  },
  text: { "margin-top": "5%", "text-align": "center" },
  buttons: { "& button": { "min-width": "100px", margin: "10px" } },
}));

const ConfirmationModal = ({
  isOpen,
  setIsOpen,
  mainBodyText,
  errorText,
  onClickYes = () => {},
  onClickNo = () => {},
  snackBarAutoHideDuration = 3000,
}: any) => {
  const classes = useStyles();
  const [snackBarOpen, setSnackBarOpen] = useState(false);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      >
        <div className={classes.main}>
          <div className={classes.text}>{mainBodyText}</div>
          <div className={classes.buttons}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                onClickYes({ setSnackBarOpen, setIsOpen });
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                setSnackBarOpen(false);
                onClickNo({ setSnackBarOpen, setIsOpen });
              }}
            >
              No
            </Button>
          </div>
        </div>
      </Modal>
      <span>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={snackBarOpen}
          autoHideDuration={snackBarAutoHideDuration}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {errorText}
          </Alert>
        </Snackbar>
      </span>
    </>
  );
};

export default ConfirmationModal;
